import { useContext } from "react";
import {RouteContext} from "../providers/RouterProvider";

export default () => useContext(RouteContext);